import deepMerge from "deepmerge";

function overwriteMerge(destinationArray, sourceArray) {
  return sourceArray;
}

const customDeepMerge = (destination, source, options = {}) => {
  if (options.mergeArrays) {
    return deepMerge(destination, source);
  } else {
    return deepMerge(destination, source, { arrayMerge: overwriteMerge });
  }
};

export default customDeepMerge;
